import React from 'react';
import API from '../../../../services/api-middleware';
import { NestedRecord, triggerConfigData } from '../../../../utils/context';
import { WorkflowFields } from '../data/workflow-data';
import { WorkflowDataTestProps } from '../automator.props';

const baseUrl = process.env.REACT_APP_LLM_SERVER_URL;

// get all workflow projects
export const getWorkflowProjectsList = async (payload: {
  search?: string;
  limit?: number;
  offset?: number;
}) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `workflows/projects?limit=${payload?.limit}&offset=${payload?.offset}&search=${payload?.search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// create new workflow project
export const createNewWorkflowProject = async (payload: { name: string; description: string }) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/projects`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// edit existing workflow project
export const editExistingWorkflowProject = async (
  payload: {
    name: string;
    description: string;
  },
  id: number | undefined,
) => {
  const data = {
    ...payload,
    project_id: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`workflows/projects`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// delete workflow project
export const deleteExistingWorkflowProject = async (id: number) => {
  const data = {
    id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`workflows/projects`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// To get the triggers and there input fields
export const getTriggersInputFields = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`workflows/catalogue/triggers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// create new workflow
export const createNewWorkflow = async (payload: { project_id: string }) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/flows`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// To get the Actions and there input fields
export const getActionInputFields = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`workflows/catalogue/actions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postWorkFlowTrigger = async (payload: {
  id?: number | undefined;
  workflow_id?: number;
  trigger_catalogue_id?: string;
  trigger_config?: triggerConfigData;
}) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/triggers`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postWorkFlowAction = async (payload: {
  id?: string | undefined;
  workflow_id?: string;
  trigger_catalogue_id?: string;
  trigger_config?: triggerConfigData;
  order?: number;
}) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/action`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteActionWorkflow = async (payload: NestedRecord) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(
      `/workflows/${data.workflow_id}/action/${data.actionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllAssistantsInFlow = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    // const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(`assistant?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllPublicAssistantsInFlow = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    // const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(`assistant/public?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllGatewaysInFlow = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    // const encodedFilters = encodeURIComponent(JSON.stringify(payload.filters));
    const response = await API(baseUrl).get(`gateway?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPreviousResponseKeys = (targetItem: NestedRecord) => {
  if (!targetItem) return [];

  const collectKeysWithDollarPaths = (obj: NestedRecord, parentPath = ''): string[] => {
    return Object.entries(obj).flatMap(([key, value]) => {
      const currentPath = parentPath ? `${parentPath}.$${key}` : `$${key}`;
      return [
        currentPath,
        ...(typeof value === 'object' && value !== null
          ? collectKeysWithDollarPaths(value, currentPath)
          : []),
      ];
    });
  };

  return collectKeysWithDollarPaths(targetItem);
};

export const getAssistantDetailsInFlow = async (appId: number) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`assistant/${appId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTriggerResponse = async (payload: NestedRecord) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `workflow/${data?.workflow_id}/trigger/${data?.triggerId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postActionResponse = async (payload: WorkflowDataTestProps) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/action/execute`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// get saved workflow
export const getWorkflowData = async (payload: NestedRecord) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `project/${payload.project_id}/workflow/${payload.workflow_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const mapDynamicOptions = (
  options: object[],
  setUpdatedWorkflowPanelData: React.Dispatch<React.SetStateAction<WorkflowFields>>,
  triggerType: string,
  key?: string,
) => {
  setUpdatedWorkflowPanelData((prev) => ({
    ...prev,
    [triggerType]: {
      ...prev[triggerType as keyof WorkflowFields],
      setup: [
        ...prev[triggerType as keyof WorkflowFields].setup.map((field) => {
          if (field.props.name === key || field.props.name === triggerType) {
            return {
              ...field,
              options, // Use the passed 'options' parameter
            };
          }
          return field;
        }),
      ],
    },
  }));
};

export const publishWorkFlow = async (payload: NestedRecord) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/publish`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const runWorkFlowManually = async (payload: NestedRecord) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`workflows/flow/run`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// get previous node action response
export const getPreviousNodeActionData = async (payload: NestedRecord) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `workflows/${data?.workflow_id}/action/${data?.action_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// get previous node trigger response
export const getPreviousNodeTriggerData = async (payload: NestedRecord) => {
  const data = { ...payload };

  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `workflow/${data?.workflow_id}/trigger/${data?.trigger_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
